
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";
import { CreateBarcodeNoScanLineItemRequest } from "@/models/api/barcodeSystem/barcodeOrders/createBarcodeNoScanLineItem";
import { formatBool } from "@/utils";

const barcodeSystemModule = getModule(BarcodeSystemModule);

@Component
export default class BarcodeNoScanLineItemCreate extends Vue {
  @Prop({ default: false })
  loading: boolean;

  @Prop({ default: null })
  createBarcodeNoScanLineItemRequest: CreateBarcodeNoScanLineItemRequest;

  @Prop({default: null})
  validationMessages: string[];

  get deliveryExceptionOptions() : Array<any> {
    return this.createBarcodeNoScanLineItemRequest && this.createBarcodeNoScanLineItemRequest.deliveryExceptionOptions ? 
      this.createBarcodeNoScanLineItemRequest.deliveryExceptionOptions.map(x => ({ label: x == null ? "" : x, value: x })) :
      [];
  }

  get formatDamaged()
  {
    return formatBool(this.createBarcodeNoScanLineItemRequest.damaged);
  }

  set formatDamaged(val)
  {

  }

  formatBool(val)
  {
    formatBool(val)
  }
  
  handleDamagedChanged() {
    if(this.createBarcodeNoScanLineItemRequest.damaged)
    {
      this.createBarcodeNoScanLineItemRequest.quantityDamaged = this.createBarcodeNoScanLineItemRequest.quantity;
    }
    else
    {
      this.createBarcodeNoScanLineItemRequest.quantityDamaged = 0;
      this.createBarcodeNoScanLineItemRequest.damageComment = null;
    }
  }
}
